angular.module("appVersion", [])
.constant("version", "4.55.140");
